import { SYSLOGSERVER_API } from "../../vars";
import { showDangerToast, showSuccessToast } from "../../validation/ToastContainer";
import { securedFetch } from "../../auth/authService";


export async function getRemoteSyslogServerConfig() {
    return securedFetch(SYSLOGSERVER_API)
        .then(async response => {
            if (!response.ok) {
                return null;
            }
            else {
                return response.json();
            }
        })
        .catch(err => {
            return null;
            //showDangerToast(err.message, "Error");
        })



}




export async function saveRemoteSyslogServerConfig(syslogServer) {
    //alert('ip: '+syslogServer.ip+' --port: '+syslogServer.port+' --transport: '+syslogServer.transport)
    return securedFetch(SYSLOGSERVER_API, syslogServer, 'POST')
        .then(async response => {
            if (!response.ok) {
                const json = await response.json();
                showDangerToast(`${json.message || 'Setting Remote Syslog Server Ip was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
            } else {
                showSuccessToast('Setting Remote Syslog Server Ip is successful', 'Remote Syslog Server')
            }
            return response.ok;
        })
    // return securedFetch(`${RETENTION_API}/dbretention`, {
    //     ip: ip
    // })
    // .then(async response => {
    // if (!response.ok) {
    //     const json = await response.json();
    //     showDangerToast(`${json.message || 'Setting Remote Syslog Server Ip was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
    // } else {
    //     showSuccessToast('Setting Remote Syslog Server Ip is successful', 'Remote Syslog Server')
    // }
    //     return response.ok;
    // })
}   
